import { KeyboardArrowDown, KeyboardArrowUp, FolderOpen } from '@lichtblick/icons';
import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';
export const TreeContainer = styled.div<{ $isMobile?: boolean }>`
  border: 1px solid ${Colors.blue['20']};
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  ${({ $isMobile }) =>
    $isMobile &&
    `
      max-height: 80vh;
      overflow-y: auto;
    `}
`;

export const Folder = styled.div<{ $isActivePath: boolean; $isSelected: boolean; $level: number }>`
  align-items: center;
  background-color: ${(props) => {
    if (props.$isSelected) {
      return Colors.blue['20'];
    }

    if (props.$isActivePath) {
      return Colors.blue['5'];
    }

    return props.$level === 0 ? Colors.blue['5'] : 'transparent';
  }};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding-bottom: ${Spacing.Xxs};
  padding-left: ${(props) => (props.$level === 0 ? '0.5rem' : `${props.$level * 1.25}rem`)};
  padding-right: ${Spacing.Xxs};
  padding-top: ${Spacing.Xxs};
  user-select: none;
  -webkit-user-select: none;
`;

export const File = styled.div<{ $level: number }>`
  margin: 2px 0;
  padding-left: ${(props) => props.$level * 20 + 20}px;
`;

export const ArrowDown = styled(KeyboardArrowDown)`
  color: ${Colors.blue['50']};
`;

export const ArrowUp = styled(KeyboardArrowUp)`
  color: ${Colors.blue['50']};
`;
export const FolderIcon = styled(FolderOpen)`
  color: ${Colors.blue['50']};
`;

export const Container = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  gap: ${Spacing.S};
  height: 90vh;
  min-height: 0;
  min-width: 0;
  padding: ${({ $isMobile }) => ($isMobile ? Spacing.Xxs : Spacing.S)};
`;
export const LeftSidebar = styled.div`
  display: flex;
  flex: 0 1 28%;
  flex-direction: column;
  gap: ${Spacing.Xxs};
  max-width: 320px;
  min-width: 180px;
  overflow-y: auto;
  width: 28%;
`;
export const RightSidebar = styled.div`
  display: flex;
  flex: 0 1 22%;
  flex-direction: column;
  gap: ${Spacing.Xxs};
  max-width: 320px;
  min-width: 160px;
  width: 22%;
  @media (max-width: 1600px) {
    max-width: 180px;
    min-width: 80px;
    width: 16%;
  }
  @media (max-width: 900px) {
    display: none;
  }
`;

export const MainContainer = styled.div<{ $contentPadding?: string }>`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: ${Spacing.Xxs};
  min-width: 0;
  overflow-y: auto;
  padding: ${({ $contentPadding }) => $contentPadding ?? 'var(--spacing-s)'};
`;

export const FolderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: ${Spacing.Xxs};
`;

export const BtnWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: ${Spacing.S};
`;

export const ActionButtons = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.S};
`;
